export default "__VITE_ASSET__C9X7JE7K__"